import { createContext } from "react";

const TopicContext = createContext({});

export default TopicContext;
